const styles = theme => ({
    root: {
        flexGrow: 1
    },
    grow: {
        flexGrow: 1,
    },
    main: {
        // marginTop : "25px"
    },
    container: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
    },
    spacer: {
        padding: "10px",
    },
    message: {
        paddingLeft: "30px",
    },
    formContainer: {
        marginTop: "20px",
        paddingLeft: "30px",
        paddingRight: "200px",
    },
    inputContainer: {
        marginTop: "20px",
    },
    buttonContainer: {
        marginTop: "20px",
        marginBottom: "20px",
    },
});

export default styles;
